import axios from 'axios';
import {Platform} from 'react-native';
import {store} from '../redux/configs';

/* switch this for testing on staging or production */

let staging = false;

var OSNAME = Platform.OS.toLowerCase();
if (OSNAME === 'android' || OSNAME === 'ios' || OSNAME === 'web') {
  staging = false;
}
if (process.env.REACT_APP_ENV === 'DEV') {
  staging = true;
}
// staging = true;
//export const apiRootStaging = 'https://apistage.startutor.my/api';
export const apiRootStaging = 'http://localhost:5555';
export const apiRootProduction = 'https://apiv1.startutor.my/api';
export const apiRoot = staging ? apiRootStaging : apiRootProduction;

export const client = axios.create({
  baseURL: apiRoot,
  timeout: 100000,
  headers: {
    'x-api-key': 'OGXDVwlBcFBGZ4NYzjH8aipE8k2Lgz14clBlz20h',
  },
});

// Add a request interceptor
client.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    // console.log('Starting Request', JSON.stringify(config, null, 2));
    const basicAuth = store.getState().auth.accessToken;
    if (basicAuth) {
      config.headers.authorization = basicAuth;
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log('request error', error);
    return Promise.reject(error);
  },
);

// Add a response interceptor
client.interceptors.response.use(
  (response) => {
    // Do something with response data
    // console.log('success response', JSON.stringify(response, null, 2));
    return response;
  },
  (error) => {
    // Do something with response error
    console.log('response error', error);
    return Promise.reject(error);
  },
);
